import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { MemberProfile } from "./MemberProfile";
import { patientDetailKeys } from "./api/keyFactory";
import { usePatientDetails } from "./api/queries/usePatientDetails";

// Once we refactor all Profile tabs to functional components this will be deprecated
export function MemberProfileContainer(props) {
  const { patientId } = useParams();
  const queryClient = useQueryClient();
  const { data: patientDetails } = usePatientDetails({ patientId });
  const waitlistChangeCount = useSelector((state) => state.patient.waitlistChangeCount);

  if (!patientDetails) return null;

  const refetchPatientDetails = () =>
    queryClient.invalidateQueries({ queryKey: patientDetailKeys.details(patientId) });

  return (
    <MemberProfile
      {...props}
      patientDetails={patientDetails}
      refetchPatientDetails={refetchPatientDetails}
      waitlistChangeCount={waitlistChangeCount}
    />
  );
}
